"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RosterSdk = require('@nackle/roster-sdk');

var _require = require('../utils/endpoints'),
    rosterUrl = _require.rosterUrl;

var _require2 = require('../utils/error'),
    throwServiceError = _require2.throwServiceError;

var SERVICE_NAME = 'roster';
var DEFAULT_SEARCH_FIELDS = ['email', 'completeName', 'username', 'department', 'jobTitle'];

module.exports = function (_ref) {
  var fetch = _ref.fetch;
  var sdk = new RosterSdk(rosterUrl, fetch);

  var genericSearchPersons = function genericSearchPersons(_ref2) {
    return new Promise(function ($return, $error) {
      var searchText, pageNumber, pageSize, _ref2$personPropertie, personProperties, _ref2$searchFields, searchFields;

      searchText = _ref2.searchText, pageNumber = _ref2.pageNumber, pageSize = _ref2.pageSize, _ref2$personPropertie = _ref2.personProperties, personProperties = _ref2$personPropertie === void 0 ? [] : _ref2$personPropertie, _ref2$searchFields = _ref2.searchFields, searchFields = _ref2$searchFields === void 0 ? DEFAULT_SEARCH_FIELDS : _ref2$searchFields;
      return Promise.resolve(sdk.searchPersons({
        personProperties: personProperties,
        genericSearch: {
          searchFields: searchFields,
          searchText: searchText
        },
        pageNumber: pageNumber,
        pageSize: pageSize,
        status: 'active'
      })).then($return, $error);
    });
  };

  var getPersonDetailed = function getPersonDetailed(personId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var personProperties, person;
      personProperties = $args.length > 1 && $args[1] !== undefined ? $args[1] : [];

      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      var $Try_1_Catch = function (error) {
        try {
          throwServiceError(SERVICE_NAME, error, 'getPersonById');
          return $Try_1_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      try {
        return Promise.resolve(sdk.getPersonDetailed(personId, {
          personProperties: personProperties
        })).then(function ($await_4) {
          try {
            person = $await_4;
            return $return(_objectSpread(_objectSpread({}, person), {}, {
              personId: person.id
            }));
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (error) {
        $Try_1_Catch(error)
      }
    });
  };

  var searchPersons = function searchPersons(filter) {
    return new Promise(function ($return, $error) {
      var $Try_2_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      var $Try_2_Catch = function (error) {
        try {
          throwServiceError(SERVICE_NAME, error, 'searchPersons');
          return $Try_2_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      try {
        return Promise.resolve(sdk.searchPersons(filter)).then($return, $Try_2_Catch);
      } catch (error) {
        $Try_2_Catch(error)
      }
    });
  };

  return {
    genericSearchPersons: genericSearchPersons,
    getPersonDetailed: getPersonDetailed,
    searchPersons: searchPersons
  };
};
//# sourceMappingURL=roster.js.map